import { create } from "zustand";

interface GuidesStore {
  catalogOpen: boolean;
  openWalkthroughId: string | null;
  openAtFeatureId: string | null;
  /** Section to auto-scroll to after the walkthrough content mounts. */
  pendingSectionId: string | null;
  setCatalogOpen: (open: boolean) => void;
  openWalkthrough: (id: string, sectionId?: string) => void;
  closeWalkthrough: () => void;
  clearPendingSection: () => void;
  openCatalogAtFeature: (featureId: string) => void;
}

export const useGuidesStore = create<GuidesStore>((set) => ({
  catalogOpen: false,
  openWalkthroughId: null,
  openAtFeatureId: null,
  pendingSectionId: null,
  setCatalogOpen: (open) =>
    set((state) => ({
      catalogOpen: open,
      openAtFeatureId: open ? state.openAtFeatureId : null,
    })),
  openWalkthrough: (id, sectionId) =>
    set({
      catalogOpen: false,
      openWalkthroughId: id,
      openAtFeatureId: null,
      pendingSectionId: sectionId ?? null,
    }),
  closeWalkthrough: () => set({ openWalkthroughId: null, pendingSectionId: null }),
  clearPendingSection: () => set({ pendingSectionId: null }),
  openCatalogAtFeature: (featureId) =>
    set({ catalogOpen: true, openAtFeatureId: featureId }),
}));
